export default {
  ERROR_MESSAGE: "Произошла ошибка",
};
